module.exports = __webpack_public_path__ + "img/icon_list.732a7ef2.svg";